export default __webpack_public_path__ + "495665007cf6aea774aba0462550d065.png";